import { SchemaField } from '../../../../../objects/generic/serialization/schema-field';
import { CommunicationsRequestSchema } from '../../generic/communications-request/communications-request-schema';

export class CommunicationsRequestConferenceParticipantCreateSchema extends CommunicationsRequestSchema {
  public static readonly conferenceFriendlyName = 'conferenceFriendlyName';

  public static readonly to = 'to';

  ////////////////////////////////////////////////////////////////////////////////////////////////
  // Schema Definition
  ////////////////////////////////////////////////////////////////////////////////////////////////

  public getSchemaDefinition(): { [key: string]: import('joi').AnySchema } {
    const parameters = super.getSchemaDefinition();

    parameters[CommunicationsRequestConferenceParticipantCreateSchema.conferenceFriendlyName] =
      SchemaField.autoGeneratedDocId(undefined).required();
    parameters[CommunicationsRequestConferenceParticipantCreateSchema.to] = SchemaField.e164Phone(undefined).required();

    return parameters;
  }
}
